var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTemplates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#BABABA;stroke-width:2.2934;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#D2D2D2;}\n\t.st4{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2934;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:none;stroke:#BABABA;stroke-width:1.6283;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.3,67.8v9.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.4,72.7h9.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.1,29.6v9.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,34.6h9.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.9,11.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C130.6,10.1,131.6,11.1,132.9,11.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.9,100.5c-19.2,0-38.7-0.8-57-5.9c-17.9-5-34.4-14.6-49.1-25.8c-9.6-7.3-18.3-13-30.8-12.2 c-12.2,0.7-23.9,5.3-33.3,13.1c-15.9,13.8-13.5,39.5-7.1,57.6c9.5,27.2,38.6,46.1,63.3,58.5c28.5,14.2,59.8,22.5,91.2,27.3 c27.5,4.2,62.9,7.2,86.7-10.8c21.9-16.5,27.9-54.2,22.5-79.7c-1.3-7.5-5.3-14.3-11.3-19.1c-15.4-11.2-38.3-3.7-55.6-3.3 C218,100.3,211.5,100.4,204.9,100.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158,257.6c46.5,0,84.2-2.4,84.2-5.3c0-2.9-37.7-5.3-84.2-5.3c-46.5,0-84.2,2.4-84.2,5.3 C73.8,255.3,111.5,257.6,158,257.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193.7,14.2L81.6,29.4c-3.6,0.5-6.1,3.8-5.6,7.4l21.7,160.8c0.5,3.6,3.8,6.1,7.4,5.6L217.2,188 c3.6-0.5,6.1-3.8,5.6-7.4L201.1,19.9C200.6,16.3,197.3,13.7,193.7,14.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M231,37.8H117.9c-3.6,0-6.6,2.9-6.6,6.6v162.2c0,3.6,2.9,6.6,6.6,6.6H231c3.6,0,6.6-2.9,6.6-6.6V44.4 C237.5,40.8,234.6,37.8,231,37.8z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M201.6,163.8h-54.4c-2,0-3.7,1.7-3.7,3.7v0c0,2,1.7,3.7,3.7,3.7h54.4c2,0,3.7-1.7,3.7-3.7v0 C205.3,165.4,203.6,163.8,201.6,163.8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.6,194.1h-52.2c-0.6,0-1.1,0.5-1.1,1.1v0.3c0,0.6,0.5,1.1,1.1,1.1h52.2c0.6,0,1.1-0.5,1.1-1.1v-0.3 C200.8,194.6,200.3,194.1,199.6,194.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M212.9,181.9h-76.9c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5h76.9c0.8,0,1.5-0.7,1.5-1.5 C214.4,182.6,213.8,181.9,212.9,181.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227,43.2H121.8c-2.6,0-4.7,2.1-4.7,4.7v91.2c0,2.6,2.1,4.7,4.7,4.7H227c2.6,0,4.7-2.1,4.7-4.7V47.9 C231.7,45.3,229.6,43.2,227,43.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M188.5,115.6c0.7,0,1.5-0.3,2.1-0.7c0.6-0.4,1.1-1.1,1.3-1.8c0.2-0.7,0.3-1.5,0.1-2.2c-0.2-0.7-0.6-1.4-1.2-1.9 c-4.8-4-10.8-6.1-17-6.1c-6.2,0.1-12.2,2.3-16.9,6.3c-0.6,0.5-1,1.1-1.2,1.8c-0.2,0.7-0.2,1.5,0.1,2.2c0.2,0.7,0.7,1.3,1.3,1.7 c0.6,0.4,1.3,0.7,2.1,0.7L188.5,115.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.2,92.6l-13.4-7.7l13.4-7.7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.5,92.6l13.4-7.7l-13.4-7.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.2,141.5v9.9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.3,146.4h9.9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.2,148.5c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2 C251.9,147.5,252.9,148.5,254.2,148.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTemplates);
export default __webpack_public_path__ + "static/media/no-templates.0c5d8f653be5bba8d1a7396424c0e9d7.svg";
export { ForwardRef as ReactComponent };